<template>
  <div data-qa="error-handler" class="notifications">
    <notification
      v-for="message in messages"
      :key="message.id"
      :message="message"
      timeout="5000"
      @destroy="removeMessage(message)"
    />
  </div>
</template>

<script>
import notification from '@/components/generic/presentational/atoms/notification/Notification.vue'

export default {
  components: {
    notification,
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      messages: [],
    }
  },
  created() {
    window.VUE_CLI_EXPORTS.plugins.EventBus.$on('notification-warning', (data) =>
      Array.isArray(data)
        ? this.handleNotifications(data, 'warning')
        : this.handleNotification(data, 'warning')
    )

    window.VUE_CLI_EXPORTS.plugins.EventBus.$on('notification-success', (data) =>
      Array.isArray(data)
        ? this.handleNotifications(data, 'success')
        : this.handleNotification(data, 'success')
    )

    window.VUE_CLI_EXPORTS.plugins.EventBus.$on('notification-info', (data) =>
      Array.isArray(data)
        ? this.handleNotifications(data, 'info')
        : this.handleNotification(data, 'info')
    )
  },
  methods: {
    handleNotification(msg, type) {
      let translationExists = this.i18n.translationExists(msg)
      const translatedMessage = translationExists ? this.i18n.t(msg) : msg

      const id = this.getRandomString()

      this.messages.push({
        text: translatedMessage,
        id,
        type,
      })
    },
    getRandomString() {
      let random_string = ''
      let random_ascii
      for (let i = 0; i < 10; i++) {
        random_ascii = Math.floor(Math.random() * 25 + 97)
        random_string += String.fromCharCode(random_ascii)
      }
      return random_string
    },
    handleNotifications(messages, type) {
      messages.forEach((msg) => {
        this.handleNotification(msg, type)
      })
    },
    removeMessage(message) {
      this.messages.splice(this.messages.indexOf(message), 1)
    },
  },
}
</script>
<style lang="scss" scoped>
@include sr-only;
.notifications {
  position: fixed;
  left: 16px;
  bottom: 16px;
  z-index: z-index(error-handler);
}
</style>
